/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportUtilizationPercentages } from './reportUtilizationPercentages';
import { ReportUtilizationTotal } from './reportUtilizationTotal';
import { ReportMachineUtilizationAvgPerDay } from './reportMachineUtilizationAvgPerDay';
import { ReportMachineUtilizationDaily } from './reportMachineUtilizationDaily';


export interface ReportMachineUtilization { 
    total?: ReportUtilizationTotal;
    percentages?: ReportUtilizationPercentages;
    avg_per_day?: ReportMachineUtilizationAvgPerDay;
    daily_view?: Array<ReportMachineUtilizationDaily>;
}

